// src/context/AuthContext.js
import React, { createContext, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [authTokens, setAuthTokens] = useState(() =>
    localStorage.getItem('_auth') ? localStorage.getItem('_auth') : null
  );
  const [user, setUser] = useState(() =>
    localStorage.getItem('_auth') ? jwtDecode(localStorage.getItem('_auth')) : null
  );

  const loginUser = (token) => {
    setAuthTokens(token);
    setUser(jwtDecode(token));
    localStorage.setItem('_auth', token);
  };

  const logoutUser = () => {
    setAuthTokens(null);
    setUser(null);
    localStorage.removeItem('_auth');
    localStorage.removeItem('refresh_token');
  };

  const contextData = {
    user,
    authTokens,
    loginUser,
    logoutUser,
  };

  return <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
